import React from "react";
import useInViewOnce from "./useInViewOnce";

export default function Attention({
  title = "Unser Fokus liegt auf",
  cards = [], // Array of objects: { icon, step, heading, description }
}) {


  return (
    <>
      <h2 className="h2-mb h2-md h2-lg h2-2xl text-center m-16">
        <span className="">{title}</span>
      </h2>

      <div className="service1 sp sec-bg1 bgm mt-4">
        <div className="w-[90%] 2xl:w-[70%] mx-auto p-4">
          <div
           
            className={`flex flex-wrap md:flex-nowrap justify-center my-8 gap-4 cardss stagger-section 
            `}
          >
            {cards.map((card, index) => (
              <div key={index} className="w-full md:w-1/2 lg:w-1/3">
                <div className="engagement-card transform transition-all duration-500 hover:-translate-y-4 hover:scale-105 hover:shadow-2xl ">
                  <div className="card-top">
                    <div className="icon-box">
                      <img src={card.icon} alt={card.heading} />
                    </div>
                    <span className="step-number">{card.step}</span>
                  </div>
                  <h5 className="h5-mb h5-md h5-lg h5-2xl !text-white">{card.heading}</h5>
                  <p>{card.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
